import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useNavigate } from "@tanstack/react-router"
import { signupUser } from "@/lib/api/signup.api"
import type { SignupFormValues } from "@/lib/schemas/auth.schema"
import { useAuthStore } from "@/store/auth.store"
import { claimGuestConversations } from "@/lib/copilot/claim"

import { toast } from "sonner"

export function useSignup() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (values: SignupFormValues) => signupUser(values),
    onSuccess: (_, variables) => {
      // Claim guest conversations linked to browser fingerprint
      void claimGuestConversations(queryClient)

      // Redirect to sign in page so the user signs in and completes BuyerProfileSetup
      navigate({
        to: "/login",
        search: {
          role: variables.role,
          registered: "true",
          email: variables.email,
        } as any,
      })
    },
    onError: (error: Error) => {
      console.error("Signup failed:", error.message)
      toast.error(error.message, { id: error.message })
    },
  })
}
